export default __webpack_public_path__ + "static/media/folder.56ab2e4c.svg";